import { createSelector } from 'reselect';

import { AppState } from '../../../../../store/models/app-state';

const productDetailState = (state: AppState) => state.product.detail;

export const productDetailIsValidSelector = createSelector(
    productDetailState,
    state => state.overview.isValid && state.attributes.isValid && state.prices.isValid
);
